import React from 'react';
import { FacebookIcon, InstagramIcon, StarIcon, PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer style={{
    backgroundColor: '#025A8A'
  }} data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-38">
        {/* Top Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-39">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-40">
            <img src="https://cdn.magicpatterns.com/uploads/3rDr76G2xKESSQAdSYdtBE/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-12 mb-4" data-id="element-41" />
            <p style={{
            color: 'rgba(255,255,255,0.65)',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            lineHeight: 1.7
          }} data-id="element-42">
              Professional power washing and exterior cleaning for residential
              and commercial properties across the Phoenix metro area.
            </p>
          </div>

          {/* Services */}
          <div data-id="element-43">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-44">
              Services
            </h4>
            <ul className="flex flex-col gap-2.5" data-id="element-45">
              {['Backyard Cleaning', 'Commercial Cleaning', 'Driveway Cleaning', 'Paver Cleaning', 'Solar Panel Cleaning', 'Trash Can Cleaning', 'Window Cleaning'].map(s => <li key={s} data-id="element-46">
                  <a href="#services" className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-47">
                    {s}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Locations */}
          <div data-id="element-48">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-49">
              Locations
            </h4>
            <ul className="flex flex-col gap-2.5" data-id="element-50">
              {['Ahwatukee Foothills', 'Casa Grande', 'Chandler', 'Gilbert', 'Litchfield Park', 'Maricopa', 'Mesa', 'Phoenix', 'Queen Creek', 'Scottsdale', 'Sun Lakes', 'Tempe'].map(city => <li key={city} data-id="element-51">
                  <a href={`#${city.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-52">
                    {city}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-53">
            <h4 className="font-bold text-white mb-5 uppercase tracking-widest" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '13px'
          }} data-id="element-54">
              Contact
            </h4>
            <ul className="flex flex-col gap-4" data-id="element-55">
              <li data-id="element-56">
                <a href="tel:4805998442" className="flex items-center gap-3 text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-57">
                  <PhoneIcon className="h-4 w-4 flex-shrink-0" style={{
                  color: '#7BC4EA'
                }} data-id="element-58" />
                  (480) 599-8442
                </a>
              </li>
              <li data-id="element-59">
                <div className="flex items-start gap-3 text-sm" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-60">
                  <MapPinIcon className="h-4 w-4 flex-shrink-0 mt-0.5" style={{
                  color: '#7BC4EA'
                }} data-id="element-61" />
                  <span data-id="element-62">
                    45004 W. Garvey Ave.
                    <br data-id="element-63" />
                    Maricopa, AZ 85139
                  </span>
                </div>
              </li>
              <li data-id="element-64">
                <a href="mailto:info@bluecactuspowerwashing.com" className="flex items-center gap-3 text-sm transition-colors hover:text-white" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-65">
                  <MailIcon className="h-4 w-4 flex-shrink-0" style={{
                  color: '#7BC4EA'
                }} data-id="element-66" />
                  info@bluecactuspowerwashing.com
                </a>
              </li>
              <li data-id="element-67">
                <div className="flex items-start gap-3 text-sm" style={{
                color: '#7BC4EA',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-68">
                  <ClockIcon className="h-4 w-4 flex-shrink-0 mt-0.5" style={{
                  color: '#7BC4EA'
                }} data-id="element-69" />
                  <span data-id="element-70">
                    Mon–Sat: 7:00 AM – 6:00 PM
                    <br data-id="element-71" />
                    Sunday: Closed
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t mb-8" style={{
        borderColor: 'rgba(255,255,255,0.12)'
      }} data-id="element-72" />

        {/* Bottom Row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-73">
          <p className="text-sm text-center sm:text-left" style={{
          color: 'rgba(255,255,255,0.45)',
          fontFamily: 'Inter, sans-serif',
          fontSize: '13px'
        }} data-id="element-74">
            © 2024 Blue Cactus Power Washing. All rights reserved. | Powered by{' '}
            <span style={{
            color: 'rgba(255,255,255,0.6)'
          }} data-id="element-75">
              Luguensi
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-76">
            {[{
            icon: <FacebookIcon className="h-4 w-4" data-id="element-77" />,
            label: 'Facebook'
          }, {
            icon: <InstagramIcon className="h-4 w-4" data-id="element-78" />,
            label: 'Instagram'
          }, {
            icon: <StarIcon className="h-4 w-4" data-id="element-79" />,
            label: 'Google Reviews'
          }].map(({
            icon,
            label
          }) => <a key={label} href="https://google.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors hover:bg-blue-600" style={{
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: 'rgba(255,255,255,0.7)'
          }} aria-label={label} data-id="element-80">
                {icon}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}